import { PipeTransform, Pipe } from '@angular/core';
import { CustomerDto } from '@careapp-group/ng-sdk';
import { DisplayNamePipe } from './display-name.pipe';

@Pipe({
    name: 'customerselection',
    pure: true,
    standalone: false
})
export class CustomerSelectionPipe implements PipeTransform {
  transform(data: CustomerDto | Array<CustomerDto>, suffix: String = '') {
    const namePipe = new DisplayNamePipe();
    if (Array.isArray(data)) {
      if (data.length === 1) {
        return namePipe.transform(data[0]);
      } else {
        return `${data.length}` + (suffix ? ` ${suffix}` : '');
      }
    } else {
      return namePipe.transform(data);
    }
  }
}
